var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseLgWithPadding(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.81968 6.66602L6.66602 8.81968L13.8457 15.9993L6.66602 23.179L8.81968 25.3327L15.9993 18.153L23.179 25.3327L25.3327 23.179L18.153 15.9993L25.3327 8.81968L23.179 6.66602L15.9993 13.8457L8.81968 6.66602Z",
    fill: "#555555"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLgWithPadding);
export default __webpack_public_path__ + "static/media/CloseLgWithPadding.d5b021d0de9c2f7457909f22fcf3846f.svg";
export { ForwardRef as ReactComponent };